var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46124 12.7105L14.1212 18.3605C14.2142 18.4542 14.3248 18.5286 14.4467 18.5793C14.5685 18.6301 14.6992 18.6562 14.8312 18.6562C14.9633 18.6562 15.094 18.6301 15.2158 18.5793C15.3377 18.5286 15.4483 18.4542 15.5412 18.3605C15.7275 18.1731 15.832 17.9196 15.832 17.6555C15.832 17.3913 15.7275 17.1378 15.5412 16.9505L10.5912 11.9505L15.5412 7.00045C15.7275 6.81309 15.832 6.55964 15.832 6.29545C15.832 6.03127 15.7275 5.77781 15.5412 5.59045C15.4486 5.49596 15.3382 5.42079 15.2163 5.3693C15.0944 5.3178 14.9635 5.291 14.8312 5.29045C14.6989 5.291 14.5681 5.3178 14.4462 5.3693C14.3243 5.42079 14.2139 5.49596 14.1212 5.59045L8.46124 11.2405C8.35973 11.3341 8.27873 11.4477 8.22332 11.5742C8.16791 11.7007 8.13931 11.8373 8.13931 11.9755C8.13931 12.1136 8.16791 12.2502 8.22332 12.3767C8.27873 12.5032 8.35973 12.6168 8.46124 12.7105Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.40be649ee9ea60acb099018bf4282224.svg";
export { ForwardRef as ReactComponent };